window.onload = function() {
  matchHeight('.product-card__content-wrapper .heading');
  matchHeight('.product-card-badges__text');
  matchHeight('.winery-body-text');
  matchHeight('.winery-heading');
};

function matchHeight(selector) {
  // Select all elements with the specified selector
  var elements = document.querySelectorAll(selector);
  var maxHeight = 0;

  // First, find the tallest element
  elements.forEach(function(element) {
    if (element.offsetHeight > maxHeight) {
      maxHeight = element.offsetHeight;
    }
  });

  // Then, set all elements to the maxHeight
  elements.forEach(function(element) {
    element.style.height = maxHeight + 'px';
  });
}
